import { Navigate } from "react-router-dom";
import { getUserRoleFromToken, useAuth } from "./useAuth";
import { roles } from "../utils/constants.ts";

export const ProtectedRoute = ({ role, children }) => {
  const { token, tokenRole } = useAuth();
  const roleFromToken = token ? getUserRoleFromToken(token) : null;
  if (!token || (role && role !== tokenRole && role !== roleFromToken)) {
    console.log(token, role, tokenRole);
    // user is not authenticated
    if (role === roles.CLIENT) {
      return <Navigate to="/login" />;
    } else if (role === roles.ADMIN) {
      return <Navigate to="/backoffice-login" />;
    }
  }
  // user is authenticated and has the required role
  return children;
};
